<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">
      <app-filtros-reportes #ctrl [datos]="datos" [cargando]="cargando" ruta="resumen/caja"></app-filtros-reportes>

      <div style="overflow:auto;  height: 77.5vh;">
        <div id="imprimir">
          <!--Tabla -->
          <table class="table is-striped  is-fullwidth" *ngIf="!cargando " id="tabla">
            <thead>
              <tr>
                <th>No.</th>
                <th>Nivel</th>
                <th>Caja</th>
                <th>Fecha apertura</th>
                <th>Fecha cierre</th>
                <th>Provisión inicial</th>
                <th>Importe de cierre</th>
                <th>Cajero</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of ctrl.datos; let i=index">
                <th>{{ i + 1 }}</th>
                <th>{{ item.nivel_educativo }}</th>
                <th>{{ item.nombre }}</th>
                <td>{{ item.fecha_apertura | formatoFecha }}</td>
                <td>{{ item.fecha_cierre | formatoFecha }} </td>
                <td>{{ item.provision_inicial | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                <td>{{ item.importe_cierre | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                <td>{{ item.cajero?.nombre }}</td>
              </tr>
              <tr *ngIf="ctrl.datos.length == 0">
                <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
              </tr>
            </tbody>

          </table>
          <table class="table is-striped  is-fullwidth" *ngIf="!cargando" id="tabla2">
            <thead>
              <tr>
                <th align="right">
                  <div align="right">Provisión inicial</div>
                </th>
                <th>
                  <div align="left">{{ctrl.apertura | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                  </div>
                </th>
                <th></th>
              </tr>
              <tr>
                <th align="right">
                  <div align="right">Importe de cierre</div>
                </th>
                <th></th>
                <th>
                  <div align="left">{{ctrl.cierre | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                </th>
              </tr>
            </thead>

          </table>
          <table class="table is-striped  is-fullwidth" *ngIf="!cargando" id="tabla3">
            <thead>
              <tr *ngFor="let item of niveles_educativos; let i=index">
                <th style="color: blue">Total {{item.nombre}}</th>
                <th style="color: blue">
                  {{total_niveles_educativos[item.id] |
                                                                currency:configuracion.sucursal.moneda:'symbol-narrow'}}
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
